import { Divider, Grid } from '@material-ui/core';
import { getInfosIndividual } from '@webapps/business';
import { Loader, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import Achievement from '../../pages/Cvtheque/Components/detailed/Components/Achievement';
import Certification from '../../pages/Cvtheque/Components/detailed/Components/Certification';
import CompetenciesPerso from '../../pages/Cvtheque/Components/detailed/Components/CompetenciesPerso';
import CompetenciesPro from '../../pages/Cvtheque/Components/detailed/Components/CompetenciesPro';
import Description from '../../pages/Cvtheque/Components/detailed/Components/Description';
import Education from '../../pages/Cvtheque/Components/detailed/Components/Education';
import Experience from '../../pages/Cvtheque/Components/detailed/Components/Experience';
import Interest from '../../pages/Cvtheque/Components/detailed/Components/Interest';
import Language from '../../pages/Cvtheque/Components/detailed/Components/Language';
import LanguageProg from '../../pages/Cvtheque/Components/detailed/Components/LanguageProg';
import Permit from '../../pages/Cvtheque/Components/detailed/Components/Permit';
import Software from '../../pages/Cvtheque/Components/detailed/Components/Software';
import Transport from '../../pages/Cvtheque/Components/detailed/Components/Transport';
import Contact from './Components/Contact';
import Criteria from './Components/Criteria';

const ProfilAffiliate = ({ id, level, idTraining, refetch }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { data: info = {}, isLoading } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={classes.container}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Contact info={info} />
          <Divider style={{ marginTop: spacing(3) }} />
        </Grid>
        <Grid item xs={12}>
          <Criteria info={info} />
          <Divider style={{ marginTop: spacing(3) }} />
        </Grid>
        <Grid item xs={12}>
          <Description info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Education info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Experience info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Certification info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CompetenciesPro info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CompetenciesPerso info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Achievement info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Software info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Language info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <LanguageProg info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Interest info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Transport info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Permit info={info} />
          <Divider />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    margin: spacing(-4),
    marginTop: spacing(0),
    padding: spacing(1),
  },
  containerSecond: {
    width: '90%',
    margin: 'auto',
  },
});

ProfilAffiliate.propTypes = {
  id: PropTypes.string,
};

export default ProfilAffiliate;